import React, { useContext, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Formik, Form, Field } from 'formik';
import { LeadsContext } from '../Context/LeadsContext';

const FollowUpDateForms = ({appraisalData,closeModal}) => {
    const [startDate, setStartDate] = useState(new Date());

    const {updateLeadData} = useContext(LeadsContext);

    const handleDateChange = (date) => {
        setStartDate(date);
    };

    return (
        <>
            <Formik
                initialValues={{
                    followUpDate: appraisalData.callback_date_orig_obj ? appraisalData.callback_date_orig_obj : new Date(),
                    callback_Complete: false
                }}
                enableReinitialize={true}
                onSubmit={(values) => {
                    console.log('Form Submitted:', values);

                    if(values.callback_Complete) {
                        updateLeadData(appraisalData.id, 'appraisal_stage', "Completed");
                        updateLeadData(appraisalData.id, 'callback_date', "");
                    } else {
                        updateLeadData(appraisalData.id, 'callback_date', values.followUpDate.getFullYear() + "-" + (values.followUpDate.getMonth()+1) + "-" + values.followUpDate.getDate());
                    }

                    closeModal();
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form className='begin-form follow-up-form'>
                        <div className='form-group mb-4'>
                            {/*<Field type="hidden" name="followUpDate" value={values.followUpDate} />
                            <DatePicker
                                selected={values.followUpDate}
                                onChange={(date) => setFieldValue('followUpDate', date)}
                                inline 
                                disabled
                            />*/}
                            <DatePicker
                                selected={values.followUpDate}
                                inline 
                                disabled
                            />
                        </div>
                        <div className="custom-checkbox begin-checkbox me-5">
                            <Field
                                type="checkbox"
                                name="callback_Complete"
                                id="CallbackCompleteChk"
                            />
                            <label htmlFor="CallbackCompleteChk">CALLBACK COMPLETE</label>
                        </div>
                        <button type='submit' className='blue-btn md-btn text-center text-uppercase'>Save</button>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default FollowUpDateForms;
